<div class="loading" *ngIf="isShow">
  <div class="loading-background"></div>
  <cc-loading-widget [width]="40"></cc-loading-widget>
</div>
